import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Input,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingHistoryArUX = (props: any) => {
    return(
      <div
        id="CardBillingHistoryArUX-div-0"
        style={{ width: "100%", padding: "10px" }}>
        <div
          id="CardBillingHistoryArUX-div-24"
          style={{fontWeight: "bold", fontSize: "1.2rem", display: "flex", justifyContent: "space-between", }}>
          {props.languageUX === "en" ? "Payment history from the parent organization" : "ประวัติการรับชำระเงินจากจากหน่วยงานต้นสังกัด"}
        </div>
        <div
          id="CardBillingHistoryArUX-div-128">
          
          <hr
            id="CardBillingHistoryArUX-hr-129">
          </hr>
        </div>
        <Form
          id="CardBillingHistoryArUX-Form-226">
          <FormGroup
            id="CardBillingHistoryArUX-FormGroup-227"
            inline={true}
            style={{ display: "flex", alignItems: "center", padding: "0px 10px" }}>
            <FormField
              id="CardBillingHistoryArUX-FormField-230"
              inline={true}
              width={7}>
              <div
                id="CardBillingHistoryArUX-div-241"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingHistoryArUX-div-347"
                  style={{ width: "25%", }}>
                  
                  <Checkbox
                    checked={props.searchHistory?.checkedPayer}
                    id="CardBillingHistoryArUX-Checkbox-348"
                    label={props.languageUX === "en" ? "Responsible Dept." : "หน่วยงานต้นสังกัด"}
                    name="checkedPayer"
                    onChange={props.onChangeSearch}
                    style={{ fontWeight: "bold" }}>
                  </Checkbox>
                </div>
                <div
                  id="CardBillingHistoryArUX-div-310"
                  style={{ width: "75%", }}>
                  
                  <div
                    id="CardBillingHistoryArUX-div-339">
                    {props.searchBoxPayer}
                  </div>
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingHistoryArUX-FormField-312"
              inline={true}
              width={3}>
              <div
                id="CardBillingHistoryArUX-div-313"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingHistoryArUX-div-315"
                  style={{ width: "100%", }}>
                  
                  <Checkbox
                    checked={props.searchHistory?.checkedStatus}
                    id="CardBillingHistoryArUX-Checkbox-317"
                    label={props.languageUX === "en" ? "Receipt status" : "สถานะใบเสร็จ"}
                    name="checkedStatus"
                    onChange={props.onChangeSearch}
                    style={{ fontWeight: "bold" }}>
                  </Checkbox>
                </div>
                <div
                  id="CardBillingHistoryArUX-div-316"
                  style={{ width: "100%", }}>
                  
                  <Dropdown
                    fluid={true}
                    id="CardBillingHistoryArUX-Dropdown-318"
                    name="status"
                    onChange={props.onChangeSearch}
                    options={props.bilStatusOptions}
                    selection={true}
                    value={props.searchHistory?.status}>
                  </Dropdown>
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingHistoryArUX-FormField-304"
              inline={true}
              width={5}>
              <div
                id="CardBillingHistoryArUX-div-307"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingHistoryArUX-div-319"
                  style={{ width: "90%", }}>
                  
                  <Checkbox
                    checked={props.searchHistory?.checkedDate}
                    id="CardBillingHistoryArUX-Checkbox-323"
                    label={props.languageUX === "en" ? "Document issue date" : "วันที่ออกเอกสาร"}
                    name="checkedDate"
                    onChange={props.onChangeSearch}
                    style={{ fontWeight: "bold" }}>
                  </Checkbox>
                </div>
                <div
                  id="CardBillingHistoryArUX-div-320"
                  style={{ width: "100%", }}>
                  
                  <DateTextBox
                    id="CardBillingHistoryArUX-DateTextBox-324"
                    onChange={props.onChangeStartDate}
                    style={{ width: "100%" }}
                    value={props.searchHistory?.startDate}>
                  </DateTextBox>
                </div>
                <div
                  id="CardBillingHistoryArUX-div-321"
                  style={{ width: "15%", fontWeight: "bold", display: "flex", justifyContent: "center", margin: "0px 20px"  }}>
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </div>
                <div
                  id="CardBillingHistoryArUX-div-322"
                  style={{ width: "100%", }}>
                  
                  <DateTextBox
                    id="CardBillingHistoryArUX-DateTextBox-325"
                    onChange={props.onChangeEndDate}
                    style={{ width: "100%" }}
                    value={props.searchHistory?.endDate}>
                  </DateTextBox>
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingHistoryArUX-FormField-305"
              inline={true}
              width={1}>
              <div
                id="CardBillingHistoryArUX-div-306"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingHistoryArUX-div-340">
                  {props.buttonSearch}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardBillingHistoryArUX-div-334"
          style={{ padding: "0px 10px 10px" }}>
          
          <Table
            data={props.arReceiptList}
            getTrProps={props.selectARReceipt}
            headers={props.languageUX === "en" ? "Document Code,Responsible Dept.,Invocie No.,Date-Time,Amount,Receipt Status,Issue/Casheir" : "รหัสเอกสาร,หน่วยงานต้นสังกัด,เลขที่ใบแจ้งหนี้,วันที่-เวลา,ยอดเงิน,สถานะใบเสร็จ,ผู้ออกใบเสร็จ"}
            id="CardBillingHistoryArUX-Table-335"
            keys="code_formatted,payer_name,ar_transaction_lot_no,created_at_dt,price,status_label,created_by"
            minRows="8"
            showPagination={false}
            style={{ height: "450px" }}>
          </Table>
        </div>
        <div
          id="CardBillingHistoryArUX-div-301"
          style={{fontWeight: "bold", fontSize: "1.2rem", display: "flex", justifyContent: "space-between", }}>
          {props.languageUX === "en" ? "Payment details" : "รายละเอียดรับชำระ"}
        </div>
        <div
          id="CardBillingHistoryArUX-div-302">
          
          <hr
            id="CardBillingHistoryArUX-hr-303">
          </hr>
        </div>
        <div
          id="CardBillingHistoryArUX-div-274"
          style={{ padding: "10px 0px", ...(props.orderBy !== "Mode" && { display: "none" }) }}>
          
          <Table
            data={props.arModeData}
            headers="รหัส,หมวดค่าใช้จ่าย,ส่งเบิก,รับชำระ"
            id="CardBillingHistoryArUX-Table-276"
            keys="bill_mode_code,bill_mode_name,total_send_claim_price,total_paid_price"
            minRows={10}
            showPagination={false}
            style={{ height: "350px" }}
            widths="^30,^150,^60,^60">
          </Table>
        </div>
        <div
          id="CardBillingHistoryArUX-div-298"
          style={{ padding: "10px 0px", ...(props.orderBy !== "Item" && { display: "none" }) }}>
          
          <Table
            data={props.arItemData}
            headers="CODE,PRODUCT,MODE,จำนวน,ส่งเบิก,รับชำระ"
            id="CardBillingHistoryArUX-Table-300"
            keys="product_code,product_name,bill_mode_name,quantity,total_send_claim_price,total_paid_price"
            minRows="8"
            showPagination={false}
            style={{ height: "350px" }}>
          </Table>
        </div>
        <div
          id="CardBillingHistoryArUX-div-275"
          style={{ display: "flex", margin: "10px 0px" }}>
          
          <div
            id="CardBillingHistoryArUX-div-277"
            style={{ display: "flex" }}>
            
            <Button
              className={props.orderBy === "Mode" && "active"}
              color="teal"
              id="btn-billMode"
              name="Mode"
              onClick={props.onChangeOrderBy}
              size="mini">
              {props.languageUX === "en" ? "BY MODE" : "ตามหมวดสินค้า/บริการ"}
            </Button>
            <Button
              className={props.orderBy === "Item" && "active"}
              color="teal"
              id="btn-billItem"
              name="Item"
              onClick={props.onChangeOrderBy}
              size="mini">
              {props.languageUX === "en" ? "BY ITEM" : "ตามรายการ"}
            </Button>
          </div>
          <div
            id="CardBillingHistoryArUX-div-294"
            style={{ flex: 1 }}>
            
          </div>
          <div
            id="CardBillingHistoryArUX-div-281"
            style={{ display: "flex" }}>
            
            <div
              id="CardBillingHistoryArUX-div-285"
              style={{ display: "flex", width: "100%", alignItems: "center" }}>
              
              <div
                id="CardBillingHistoryArUX-div-288"
                style={{ margin: "0px 10px", width: "55%" }}>
                {props.languageUX === "en" ? "Claim submit" : "ส่งเบิก"}
              </div>
              <Input
                id="CardBillingHistoryArUX-Input-291"
                readOnly="true"
                size="mini"
                style={{ width: "62%" }}
                value={props.invoiceTotalSendClaimPrice}>
              </Input>
            </div>
            <div
              id="CardBillingHistoryArUX-div-286"
              style={{ display: "flex", width: "100%", alignItems: "center" }}>
              
              <div
                id="CardBillingHistoryArUX-div-289"
                style={{ margin: "0px 10px", width: "55%" }}>
                {props.languageUX === "en" ? "Payment Received" : "รับชำระ"}
              </div>
              <Input
                id="CardBillingHistoryArUX-Input-292"
                readOnly="true"
                size="mini"
                style={{ width: "62%" }}
                value={props.invoiceTotalRemainPrice}>
              </Input>
            </div>
          </div>
        </div>
        <div
          id="CardBillingHistoryArUX-div-327"
          style={{ display: "flex", justifyContent: "flex-end", margin: "15px 0px" }}>
          
          <div
            id="CardBillingHistoryArUX-div-328"
            style={{ display: "flex", margin: "0px 15px", width: "450px" }}>
            
            <div
              id="CardBillingHistoryArUX-div-332"
              style={{ display: "flex", alignItems: "center", fontWeight: "bold", width: "70%"  }}>
              {props.languageUX === "en" ? "Name on Receipt " : "ชื่อหน่วยงานบนใบเสร็จ"}
            </div>
            <div
              id="CardBillingHistoryArUX-div-341"
              style={{ width: "100%" }}>
              {props.searchBoxPayerReceipt}
            </div>
          </div>
          <div
            id="CardBillingHistoryArUX-div-342">
            {props.printARReceiptCopy}
          </div>
          <div
            id="CardBillingHistoryArUX-div-343">
            {props.printPaymentARReport}
          </div>
          <Button
            color="red"
            disabled={props.disabledButton}
            id="CardBillingHistoryArUX-Button-331"
            onClick={props.cancelReceipt}
            size="small"
            style={props.buttonCancelStyle}>
            {props.languageUX === "en" ? "Cancel receipt" : "ยกเลิกใบเสร็จ"}
          </Button>
        </div>
      </div>
    )
}


export default CardBillingHistoryArUX

export const screenPropsDefault = {"debug":true,"language":"EN","showSupplyList":false}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการรับชำระเงินจากจากหน่วยงานต้นสังกัด",
          "valueEN": "Payment history from the parent organization"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", display: \"flex\", justifyContent: \"space-between\", }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-128"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "hr",
      "parent": 128,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-hr-129"
        }
      },
      "seq": 129,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Form-226"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "FormGroup",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-FormGroup-227"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding: \"0px 10px\" }"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-FormField-230"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-241"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-274"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px 0px\", ...(props.orderBy !== \"Mode\" && { display: \"none\" }) }"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-275"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 0px\" }"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 276,
      "name": "Table",
      "parent": 274,
      "props": {
        "data": {
          "type": "code",
          "value": "props.arModeData"
        },
        "headers": {
          "type": "value",
          "value": "รหัส,หมวดค่าใช้จ่าย,ส่งเบิก,รับชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Table-276"
        },
        "keys": {
          "type": "value",
          "value": "bill_mode_code,bill_mode_name,total_send_claim_price,total_paid_price"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"350px\" }"
        },
        "widths": {
          "type": "value",
          "value": "^30,^150,^60,^60"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-277"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "Button",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": "ตามหมวดสินค้า/บริการ",
          "valueEN": "BY MODE"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Mode\" && \"active\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billMode"
        },
        "name": {
          "type": "value",
          "value": "Mode"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "Button",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": "ตามรายการ",
          "valueEN": "BY ITEM"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Item\" && \"active\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billItem"
        },
        "name": {
          "type": "value",
          "value": "Item"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-281"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 285,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-285"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-286"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 285,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Claim submit"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-288"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\", width: \"55%\" }"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "div",
      "parent": 286,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระ",
          "valueEN": "Payment Received"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-289"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\", width: \"55%\" }"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 291,
      "name": "Input",
      "parent": 285,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Input-291"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"62%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceTotalSendClaimPrice"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 292,
      "name": "Input",
      "parent": 286,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Input-292"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"62%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceTotalRemainPrice"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 294,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-294"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 298,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-298"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px 0px\", ...(props.orderBy !== \"Item\" && { display: \"none\" }) }"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 300,
      "name": "Table",
      "parent": 298,
      "props": {
        "data": {
          "type": "code",
          "value": "props.arItemData"
        },
        "headers": {
          "type": "value",
          "value": "CODE,PRODUCT,MODE,จำนวน,ส่งเบิก,รับชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Table-300"
        },
        "keys": {
          "type": "value",
          "value": "product_code,product_name,bill_mode_name,quantity,total_send_claim_price,total_paid_price"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"350px\" }"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดรับชำระ",
          "valueEN": "Payment details"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-301"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", display: \"flex\", justifyContent: \"space-between\", }"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-302"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": null,
      "id": 303,
      "name": "hr",
      "parent": 302,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-hr-303"
        }
      },
      "seq": 303,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 304,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-FormField-304"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 338,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 305,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-FormField-305"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 344,
      "void": false
    },
    {
      "from": null,
      "id": 306,
      "name": "div",
      "parent": 305,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-306"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": null,
      "id": 307,
      "name": "div",
      "parent": 304,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-307"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": null,
      "id": 310,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-310"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"75%\", }"
        }
      },
      "seq": 347,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 312,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-FormField-312"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": null,
      "id": 313,
      "name": "div",
      "parent": 312,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-313"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": null,
      "id": 315,
      "name": "div",
      "parent": 313,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-315"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", }"
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": null,
      "id": 316,
      "name": "div",
      "parent": 313,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-316"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", }"
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 317,
      "name": "Checkbox",
      "parent": 315,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.searchHistory?.checkedStatus"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Checkbox-317"
        },
        "label": {
          "type": "value",
          "value": "สถานะใบเสร็จ",
          "valueEN": "Receipt status"
        },
        "name": {
          "type": "value",
          "value": "checkedStatus"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearch"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 318,
      "name": "Dropdown",
      "parent": 316,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Dropdown-318"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearch"
        },
        "options": {
          "type": "code",
          "value": "props.bilStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchHistory?.status"
        }
      },
      "seq": 318,
      "void": false
    },
    {
      "from": null,
      "id": 319,
      "name": "div",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-319"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"90%\", }"
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": null,
      "id": 320,
      "name": "div",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-320"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", }"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": null,
      "id": 321,
      "name": "div",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-321"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"15%\", fontWeight: \"bold\", display: \"flex\", justifyContent: \"center\", margin: \"0px 20px\"  }"
        }
      },
      "seq": 321,
      "void": false
    },
    {
      "from": null,
      "id": 322,
      "name": "div",
      "parent": 307,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-322"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", }"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 323,
      "name": "Checkbox",
      "parent": 319,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.searchHistory?.checkedDate"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Checkbox-323"
        },
        "label": {
          "type": "value",
          "value": "วันที่ออกเอกสาร",
          "valueEN": "Document issue date"
        },
        "name": {
          "type": "value",
          "value": "checkedDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearch"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 324,
      "name": "DateTextBox",
      "parent": 320,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-DateTextBox-324"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.searchHistory?.startDate"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 325,
      "name": "DateTextBox",
      "parent": 322,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-DateTextBox-325"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.searchHistory?.endDate"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": null,
      "id": 327,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-327"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"15px 0px\" }"
        }
      },
      "seq": 334,
      "void": false
    },
    {
      "from": null,
      "id": 328,
      "name": "div",
      "parent": 327,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-328"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"0px 15px\", width: \"450px\" }"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 331,
      "name": "Button",
      "parent": 327,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกใบเสร็จ",
          "valueEN": "Cancel receipt"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledButton"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Button-331"
        },
        "onClick": {
          "type": "code",
          "value": "props.cancelReceipt"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "props.buttonCancelStyle"
        }
      },
      "seq": 343,
      "void": false
    },
    {
      "from": null,
      "id": 332,
      "name": "div",
      "parent": 328,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อหน่วยงานบนใบเสร็จ",
          "valueEN": "Name on Receipt "
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-332"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", fontWeight: \"bold\", width: \"70%\"  }"
        }
      },
      "seq": 332,
      "void": false
    },
    {
      "from": null,
      "id": 334,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-334"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 10px 10px\" }"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 335,
      "name": "Table",
      "parent": 334,
      "props": {
        "data": {
          "type": "code",
          "value": "props.arReceiptList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.selectARReceipt"
        },
        "headers": {
          "type": "value",
          "value": "รหัสเอกสาร,หน่วยงานต้นสังกัด,เลขที่ใบแจ้งหนี้,วันที่-เวลา,ยอดเงิน,สถานะใบเสร็จ,ผู้ออกใบเสร็จ",
          "valueEN": "Document Code,Responsible Dept.,Invocie No.,Date-Time,Amount,Receipt Status,Issue/Casheir"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Table-335"
        },
        "keys": {
          "type": "value",
          "value": "code_formatted,payer_name,ar_transaction_lot_no,created_at_dt,price,status_label,created_by"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"450px\" }"
        }
      },
      "seq": 335,
      "void": false
    },
    {
      "from": null,
      "id": 339,
      "name": "div",
      "parent": 310,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxPayer"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-339"
        }
      },
      "seq": 339,
      "void": false
    },
    {
      "from": null,
      "id": 340,
      "name": "div",
      "parent": 306,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-340"
        }
      },
      "seq": 340,
      "void": false
    },
    {
      "from": null,
      "id": 341,
      "name": "div",
      "parent": 328,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxPayerReceipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-341"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 341,
      "void": false
    },
    {
      "from": null,
      "id": 342,
      "name": "div",
      "parent": 327,
      "props": {
        "children": {
          "type": "code",
          "value": "props.printARReceiptCopy"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-342"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": null,
      "id": 343,
      "name": "div",
      "parent": 327,
      "props": {
        "children": {
          "type": "code",
          "value": "props.printPaymentARReport"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-343"
        }
      },
      "seq": 342,
      "void": false
    },
    {
      "from": null,
      "id": 347,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-div-347"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"25%\", }"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 348,
      "name": "Checkbox",
      "parent": 347,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.searchHistory?.checkedPayer"
        },
        "id": {
          "type": "value",
          "value": "CardBillingHistoryArUX-Checkbox-348"
        },
        "label": {
          "type": "value",
          "value": "หน่วยงานต้นสังกัด",
          "valueEN": "Responsible Dept."
        },
        "name": {
          "type": "value",
          "value": "checkedPayer"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearch"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 348,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingHistoryArUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "EN",
    "showSupplyList": false
  },
  "width": 80
}

*********************************************************************************** */
